module.exports = __webpack_public_path__ + "img/invoice.b0f111f4.png";